import type { ReactNode } from 'react';
import { Spinner } from './spinner.js';

/**
 * A page or section still loading: its existing words ("Loading…",
 * "Checking…", "Opening…") with the spinner beside them (RE-35). `className`
 * keeps each screen's own note style - "state-note" or "empty".
 */
export function WaitNote({ className = 'state-note', children }: { className?: string; children: ReactNode }) {
  return (
    <p className={`${className} waiting`} role="status">
      <Spinner />
      {children}
    </p>
  );
}
